var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "22px",
    width: "14px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black_23_"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.837,12.885 97.923,476.257 160.23,476.257 392.352,12.885  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.949,245.008c-29.967,0-53.563,9.509-70.851,28.466c-17.257,18.957-25.893,48.127-25.893,87.434 c0,39.552,8.652,68.814,25.893,87.771c17.288,18.957,41.191,28.435,71.755,28.435c29.538,0,52.966-9.479,70.223-28.435 C481.348,429.738,490,400.46,490,360.908c0-39.307-8.652-68.477-25.924-87.434C446.819,254.517,423.084,245.008,392.949,245.008z  M413.009,418.146c-4.777,7.182-11.683,10.78-20.656,10.78c-8.774,0-15.68-3.706-20.657-11.086 c-6.615-9.616-9.876-28.665-9.876-57.208c0-28.573,3.277-47.729,9.876-57.544c4.778-7.182,11.683-10.78,20.657-10.78 c8.973,0,15.956,3.598,20.963,10.78c6.416,9.815,9.586,28.971,9.586,57.544C422.885,389.19,419.608,408.346,413.009,418.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.764,128.801c0-39.521-8.652-68.722-25.893-87.572c-17.288-18.896-41.191-28.328-71.754-28.328 c-29.538,0-52.966,9.509-70.223,28.466C8.605,60.308,0,89.479,0,128.801c0,39.552,8.605,68.753,25.893,87.603 c17.257,18.896,41.191,28.298,71.724,28.298c29.568,0,52.966-9.479,70.254-28.435C185.128,197.309,193.764,168.154,193.764,128.801 z M117.11,185.733c-5.007,7.182-11.974,10.78-20.993,10.78c-8.774,0-15.649-3.598-20.656-10.78 c-6.569-9.785-9.877-28.971-9.877-57.498c0-28.573,3.308-47.729,9.877-57.544c5.007-7.182,11.882-10.78,20.656-10.78 c9.004,0,15.986,3.706,20.993,11.086c6.37,9.616,9.586,28.665,9.586,57.238C126.695,156.762,123.48,175.964,117.11,185.733z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentBlack);
export default __webpack_public_path__ + "static/media/percent-black.312459d26cf996388e0940ce272e7568.svg";
export { ForwardRef as ReactComponent };